// Shared with backend/services/article_intelligence_service.py's _SCORE_DIMS +
// buying_stage — display labels for the 23 article.md dimensions, used by both
// ArticleDetailPage (standalone scoring) and QueryDetailPage (targeted scoring).
// first_hand_experience / original_contribution / people_first map Google's
// "helpful, reliable, people-first content" self-assessment onto the rubric;
// pyramid_structure scores Minto Pyramid / BLUF section ordering (answer first,
// then key points, then supporting detail); flow_coherence scores
// section-to-section transition quality (thought jumps), the local complement
// to pyramid_structure's global ordering.
export const INTELLIGENCE_DIMENSION_LABELS = {
  persona_clarity: "Buyer Persona",
  search_intent: "Search Intent",
  problem_clarity: "Problem Clarity",
  audience_relevance: "Audience Relevance",
  pain_point: "Pain Point",
  buying_stage: "Buying Stage",
  commercial_relevance: "Commercial Relevance",
  value_proposition: "Value Proposition",
  expertise: "Expertise",
  specificity: "Specificity",
  first_hand_experience: "First-hand Experience",
  original_contribution: "Original Contribution",
  people_first: "People-first Focus",
  pyramid_structure: "Pyramid Structure",
  flow_coherence: "Flow & Transitions",
  differentiation: "Differentiation",
  evidence: "Evidence",
  actionability: "Actionability",
  completeness: "Information Completeness",
  internal_consistency: "Internal Consistency",
  conversion_readiness: "Conversion Readiness",
  cta_relevance: "CTA Relevance",
  trust: "Trust",
};

export const INTELLIGENCE_DIMENSION_ORDER = Object.keys(INTELLIGENCE_DIMENSION_LABELS);
